// React, Next

// MUI
import Box from '@mui/material/Box'

// Custom
import HeroSection from './sections/HeroSection'
import StatisticsSection from './sections/StatisticsSection'
import ChallengesSection from './sections/ChallengesSection'
import ServicesSection from './sections/ServicesSection'
import ProcessSection from './sections/ProcessSection'
import IndustriesSection from './sections/IndustriesSection'
import FaqSection from './sections/FaqSection'
import WhyUsSection from './sections/WhyUsSection'
import CtaSection from './sections/CtaSection'

// Style
import themeColors from 'assets/theme/colors'

export default function OtCybersecurityView() {
  // *** MAIN RENDER ***
  return (
    <Box sx={{ background: themeColors.kroemtech.background }}>
      {/* The hero is full bleed and carries the breadcrumbs itself, so it also
          owns the padding that clears the fixed header. */}
      <HeroSection />

      <StatisticsSection />
      <ServicesSection />
      <ChallengesSection />
      <ProcessSection />
      <WhyUsSection />
      <IndustriesSection />
      <FaqSection />
      <CtaSection />
    </Box>
  )
}
